import OffsetFrame from '@/shared/components/OffsetFrame'

import './PriceNotice.css'

export default function PriceNotice() {
  return (
    <OffsetFrame as="aside" variant="notice" className="price-notice px-6 py-8 min-[900px]:min-h-[244px] min-[900px]:px-7 min-[900px]:py-10">
      <h2 className="price-notice__title relative">All Prices are MP</h2>
      <p className="price-notice__description relative mt-4 max-w-[225px]">MP means Market Price. Meaning the price can go up or down depending on material cost and availability.</p>
    </OffsetFrame>
  )
}
